'use client';

import { getNodesFromConnection } from '@graphql/connections/getNodesFromConnection';
import { GetDiscoveredBrands, DiscoveredBrandNodeFields } from '../../../../generated/graphql';
import { BrandCard } from '../components/BrandCard';
import { ContinuousCarousel } from '../../../../components/Carousels/ContinuousCarousel/ContinuousCarousel';
import { Container } from '../../../../components/Container/Container';

interface IProps {
  brands: GetDiscoveredBrands;
  variant: 'FeaturedBrand' | 'ActiveBrand';
  title: string;
}

export const FilteredBrands = ({ brands, variant, title }: IProps) => {
  const brandNodes = getNodesFromConnection<DiscoveredBrandNodeFields>(brands.entry);

  return (
    <Container>
      <ContinuousCarousel
        dataTestId={`${variant}-Carousel`}
        title={title}
        outerClassName="mb-md"
        childrenClassName=""
      >
        {brandNodes.map(brand => (
          <BrandCard key={brand._id} brand={brand} />
        ))}
      </ContinuousCarousel>
    </Container>
  );
};
